import { render, staticRenderFns } from "./TournamentSchedule.vue?vue&type=template&id=07f26cf6"
import script from "./TournamentSchedule.vue?vue&type=script&lang=js"
export * from "./TournamentSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports